import React, { memo } from "react";
import "./styles/index.scss";

type InvestorAvatarProps = {
  label: string;
  onClick?: (e: any) => void;
  styles?: React.CSSProperties;
};

const InvestorInnerAvatar = (props: InvestorAvatarProps) => {
  const { label, onClick, styles = {} } = props;

  return (
    <div
      className="investor-avatar"
      onClick={onClick}
      style={{
        ...styles,
      }}
    >
      <div className="investor-label">{label}</div>
    </div>
  );
};

export const InvestorAvatar = memo(InvestorInnerAvatar);
